import axios from '@/axios'
import API from '@/API'

const PREFIX = 'imei'

export default {
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  template() {
    return axios.get(`${API.endpoint}/${PREFIX}/export_template`, {
      responseType: 'blob'
    })
  },
  import(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/import`, data)
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  },
  approve(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/approve/${id}`)
  },
  exportResponse(data) {
    return axios.post(
      `${API.endpoint}/${PREFIX}/export_response`,
      { data: data },
      {
        responseType: 'blob'
      }
    )
  },
  detail_imei(id) {
    return axios.get(`${API.endpoint}/${PREFIX}/detail_imei/${id}`)
  },
  blacklist(form_data) {
    return axios.post(`${API.endpoint}/${PREFIX}/blacklist_imei`, form_data)
  }
}
